import * as React from 'react';
import { HiddenInput } from "soprasteria-ui-library";
import { IPatient } from '../../../../models/IPatient';
import { ReferralPatientInformation } from '../ReferralPatientInformation';
import { ReferralInformation } from '../ReferralInformation';
import { ReferralOtherInformation } from '../ReferralOtherInformation';
import { ReferralReferrerManualRegistration } from './ReferralReferrerManualRegistration';
import { ReferralRecipentSectionManualRegistration } from './ReferralRecipentSectionManualRegistration';
import { IReferralManualRegistration } from '../../../../models/IReferral';
import { ReferralOtherReferrer } from './ReferralOtherReferrer';

interface IReferralManualRegisterFormInputs {
    patient: IPatient;
    referralData?: IReferralManualRegistration;
}

export const ReferralManualRegisterFormInputs: React.FunctionComponent<IReferralManualRegisterFormInputs> = ({ patient, referralData }) => {

    const [showOtherReferrerInputs, setShowOtherReferrerInputs] = React.useState<boolean>(false);

    return (
        <>
            {
                referralData ?
                    <>
                        <HiddenInput name="patientId" value={patient.patientId.toString()} />

                        <ReferralPatientInformation patient={patient} isEditable={true} />
                        <hr />
                        <ReferralReferrerManualRegistration careProviders={referralData.selectableReferrers} showOtherReferrer={setShowOtherReferrerInputs} />
                        <hr />
                        {
                            showOtherReferrerInputs ?
                                <>
                                    <ReferralOtherReferrer />
                                    <hr />
                                </>
                                : null
                        }
                        <ReferralRecipentSectionManualRegistration careProvider={referralData.recipentCareProvider} specialties={referralData.recipentCareTypeFunctions} />
                        <hr />
                        <ReferralInformation manualRegistration />
                        <hr />
                        <ReferralOtherInformation manualRegistration />
                    </>
                    : null
            }
        </>
    )
}
